(() => {
  const setup = () => {
    document.querySelectorAll('.cn-product-photo').forEach(card => {
      const secondary = card.querySelector('.cn-image-secondary');
      if (!secondary || !card.querySelector('.cn-image-primary') || secondary.dataset.cnSwapBound) return;
      secondary.dataset.cnSwapBound = 'true';
      const updateReady = () => card.classList.toggle('cn-secondary-ready', secondary.complete && secondary.naturalWidth > 0);
      secondary.addEventListener('load', updateReady);
      secondary.addEventListener('error', () => card.classList.remove('cn-secondary-ready'));
      updateReady();
    });
    const disclosures = [...document.querySelectorAll('.cn-menu, .cn-search, .cn-shop-menu')];
    disclosures.forEach(el => {
      if (el.dataset.cnReady) return;
      el.dataset.cnReady = 'true';
      el.addEventListener('toggle', () => {
        if (!el.open) return;
        disclosures.forEach(other => { if (other !== el && !other.contains(el) && !el.contains(other)) other.open = false; });
        if (el.classList.contains('cn-search')) el.querySelector('input[type="search"]')?.focus();
      });
      el.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { el.open = false; }));
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cn-menu[open], .cn-search[open], .cn-shop-menu[open]').forEach(el => {
      el.open = false;
      el.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.cn-menu[open], .cn-search[open], .cn-shop-menu[open]').forEach(el => {
      if (!el.contains(event.target)) el.open = false;
    });
  });
  let backups = {};
  try { backups = JSON.parse(document.getElementById('CelinnorImageBackups')?.textContent || '{}'); } catch (_) {}
  const repairImage = img => {
    if (!(img instanceof HTMLImageElement) || img.dataset.cnRepaired) return;
    let original;
    try { original = decodeURIComponent(new URL(img.currentSrc || img.src, document.baseURI).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.)/, ''); } catch (_) { return; }
    const replacement = backups[original];
    if (!replacement) return;
    img.dataset.cnRepaired = 'true';
    img.removeAttribute('srcset');
    img.src = replacement;
  };
  document.addEventListener('error', event => repairImage(event.target), true);
  document.querySelectorAll('img').forEach(img => { if (img.complete && !img.naturalWidth) repairImage(img); });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
